import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=7127cfb0&scoped=true"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=7127cfb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127cfb0",
  null
  
)

export default component.exports